import React, { memo } from 'react';

import { Box, Skeleton } from '@mui/material';

import { HEADER_CHAT_LOADING_SKELETON_ROW_KEYS } from './HeaderChatLoadingSkeleton.constants';
import { skeletonBodyStyles, skeletonRowStyles } from './HeaderChatLoadingSkeleton.styles';

const HeaderChatLoadingSkeleton = memo(() => (
  <>
    {HEADER_CHAT_LOADING_SKELETON_ROW_KEYS.map(key => (
      <Box key={key} sx={skeletonRowStyles}>
        <Skeleton height={36} variant="circular" width={36} />
        <Box sx={skeletonBodyStyles}>
          <Skeleton height={12} variant="text" width="60%" />
          <Skeleton height={12} variant="text" width="85%" />
        </Box>
      </Box>
    ))}
  </>
));

export default HeaderChatLoadingSkeleton;
